export default __webpack_public_path__ + "static/media/homeHero.3b1f2a37.png";